import { Credit } from '@src/containers/Blotters/Credit';
import type { CreditBlotterPanelConfig } from '@src/types/LayoutConfig';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function CreditPanel({ params, api }: LayoutPanelProps<CreditBlotterPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.CreditBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="credit-blotter-panel"
      >
        <Credit />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
